import { useState, useEffect } from 'react';

const postCache = {};

export default function useBlogPost(slug) {
  const [post, setPost] = useState(postCache[slug] || null);
  const [loading, setLoading] = useState(!postCache[slug]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) return;
    if (postCache[slug]) {
      setPost(postCache[slug]);
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchPost() {
      try {
        const res = await fetch(`/content/blog/posts/${slug}.json`);
        if (!res.ok) throw new Error('Post not found');
        const data = await res.json();

        if (!cancelled) {
          postCache[slug] = data;
          setPost(data);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      }
    }

    fetchPost();
    return () => { cancelled = true; };
  }, [slug]);

  return { post, loading, error };
}
